/**
 * Trạng thái hoạt động
 * nddat1 30/01/2023
 */
export default {
  CalculateReserve1: 1,
  CalculateReserve2: 2,
  CalculateReserve3: 3,
};
